import { useState } from 'react'
import { Button, Tooltip } from 'antd'
import { customerSendPermissions } from '@super-mega/server/contracts/bill'
import { useAccess } from '@/hooks/use-access.ts'
import { CustomerSendModal } from './customer-send-modal.tsx'

export function CustomerSendButton({
  customerId,
  customerName,
  wecomChatId,
  disabled
}: {
  customerId: number
  customerName: string
  wecomChatId?: string | null
  disabled?: boolean
}) {
  const access = useAccess()
  const [open, setOpen] = useState(false)
  const [active, setActive] = useState(false)
  if (!access.all(customerSendPermissions)) return null
  return (
    <>
      <Tooltip title={!wecomChatId ? '请先为客户绑定企微群 ID' : undefined}>
        <span>
          <Button
            disabled={disabled || !wecomChatId}
            onClick={() => {
              setActive(true)
              setOpen(true)
            }}
          >
            发送收款账单
          </Button>
        </span>
      </Tooltip>
      {active && (
        <CustomerSendModal
          customerId={customerId}
          customerName={customerName}
          open={open}
          onClose={() => setOpen(false)}
          afterClose={() => setActive(false)}
        />
      )}
    </>
  )
}
